import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

const STYLE_IDS = {
  animation: 'pb-a11y-injected-animation',
  transition: 'pb-a11y-injected-transition',
};

function injectGlobalStyle(id, cssText) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const style = document.createElement('style');
  style.id = id;
  style.textContent = cssText;
  document.head.appendChild(style);
}

function removeGlobalStyle(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export function applyStopAnimations(enabled) {
  toggleHtmlClass(CLASSES.hideAnimations, enabled);
  if (enabled) {
    injectGlobalStyle(
      STYLE_IDS.animation,
      '*, *::before, *::after { animation-duration: 0s !important; animation-delay: 0s !important; }'
    );
  } else {
    removeGlobalStyle(STYLE_IDS.animation);
  }
}

export function applyReduceTransitions(enabled) {
  toggleHtmlClass(CLASSES.reduceTransitions, enabled);
  if (enabled) {
    injectGlobalStyle(
      STYLE_IDS.transition,
      '*, *::before, *::after { transition-duration: 0s !important; transition-delay: 0s !important; }'
    );
  } else {
    removeGlobalStyle(STYLE_IDS.transition);
  }
}

export function applyDisableAutoplay(enabled) {
  document.querySelectorAll('video, audio, iframe').forEach((el) => {
    if (enabled) {
      el.setAttribute('data-pb-a11y-autoplay-saved', el.autoplay ? 'true' : 'false');
      if (el.autoplay) {
        el.autoplay = false;
        if (typeof el.pause === 'function') el.pause();
      }
    } else {
      const saved = el.getAttribute('data-pb-a11y-autoplay-saved');
      if (saved === 'true') {
        el.autoplay = true;
        if (typeof el.play === 'function') el.play().catch(() => {});
      }
      el.removeAttribute('data-pb-a11y-autoplay-saved');
    }
  });
}
